export default "__VITE_ASSET__43190c06__"